<template>
  <div class="etms-router-body">
    <ul class="line-type-ul">
      <li v-for="item in constant.linetypes" :key="item.value" class="line-type-li fl" @click="linetypeClick(item)">
        <div :class="(item.value === search.LineType?'active':'')">{{item.label}}线路</div>
      </li>
      <li class="clear"></li>
    </ul>
    <div class="etms-router-search">
      <span class="etms-router-search-label fl">渠道：</span>
      <el-select size="mini" placeholder="选择渠道搜索" class="etms-router-search-element fl" filterable clearable v-model="search.ChannelId">
        <el-option v-for="item in channellist" :key="item.id" :value="item.id" :label="item.channelName"></el-option>
      </el-select>
      <span class="etms-router-search-label fl">线路名：</span>
      <el-input size="mini" placeholder="填写线路名搜索" class="etms-router-search-element fl" v-model="search.LineName"></el-input>
      <el-tooltip class="item" content="添加" placement="top">
        <el-button size="mini" type="primary" icon="el-icon-plus" class="etms-router-search-button fr" circle @click="insertChannelLine"></el-button>
      </el-tooltip>
      <el-tooltip class="item" content="导入" placement="top">
        <el-button size="mini" type="primary" icon="el-icon-upload2" class="etms-router-search-button fr" circle @click="uploadChannelLine"></el-button>
      </el-tooltip>
      <el-tooltip class="item" content="搜索" placement="top">
        <el-button size="mini" type="primary" icon="el-icon-search" class="etms-router-search-button fr" circle @click="searchClick"></el-button>
      </el-tooltip>
      <div class="clear">
      </div>
    </div>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="search.pageindex" :page-sizes="constant.pagesizes" :page-size="search.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="search.recordcount"></el-pagination>
    <el-table :data="channellinelist" :border="true" height="80%" class="etms-router-list">
      <el-table-column label="序号" type="index" align="center" width="60px"></el-table-column>
      <el-table-column label="渠道" prop="channelName" align="center" width="150px" :formatter="formatterChannelName"></el-table-column>
      <el-table-column label="线路名" prop="lineName" align="center" width="100px"></el-table-column>
      <el-table-column label="线路代码" prop="lineCode" align="center" width="100px"></el-table-column>
      <el-table-column align="center" width="150px" prop="shipmentName" :formatter="formatterShipmentName">
        <template slot="header" slot-scope="scope">
          起运{{search.LineTypeLabel}}
        </template>
      </el-table-column>
      <el-table-column label="追踪状态" prop="trackState" align="center" width="100px">
        <template slot-scope="scope">
          {{scope.row.trackState?'可追踪':'不可追踪'}}
        </template>
      </el-table-column>
      <el-table-column label="预计天数" prop="estimatedMinDays" align="center" width="100px">
        <template slot-scope="scope">
          {{scope.row.estimatedMinDays}}-{{scope.row.estimatedMaxDays}}天
        </template>
      </el-table-column>
      <el-table-column align="center" prop="purposeString" :formatter="formatterPurpose">
        <template slot="header" slot-scope="scope">
          目的{{search.LineTypeLabel}}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="100px">
        <template slot-scope="scope">
          <el-tooltip content="修改" placement="top">
            <el-button size="mini" type="primary" icon="el-icon-edit-outline" circle @click="updateChannelLine(scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip content="删除" placement="top">
            <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteChannelLine(scope.row)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="dialogInsert.dialogtitle" :visible.sync="dialogInsert.dialogvisible" :modal-append-to-body="false" center width="750px">
      <el-tabs v-model="dialogInsert.activename">
        <el-tab-pane label="线路信息" name="lineinfo">
          <el-form :model="dialogInsert.form" :ref="dialogInsert.form.formname" :rules="dialogInsert.rules" label-width="120px" class="etms-dialog-form">
            <el-form-item label="渠道：" prop="ChannelId">
              <el-select size="mini" placeholder="请选择渠道" v-model="dialogInsert.form.ChannelId" filterable class="el-width-200">
                <el-option v-for="item in channellist" :key="item.id" :value="item.id" :label="item.channelName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="代码：" prop="LineCode">
              <el-input size="mini" placeholder="请填写线路代码" v-model="dialogInsert.form.LineCode" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="名称：" prop="LineName">
              <el-input size="mini" placeholder="请填写线路名" v-model="dialogInsert.form.LineName" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="起运地区：">
              <el-select size="mini" placeholder="请选择起运地区" class="el-width-200" filterable v-model="dialogInsert.form.ShipmentRegion">
                <el-option v-for="item in countrylist" :key="item.id" :value="item.id" :label="item.countryName_CN[0]+'['+item.twoLetters+']'"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="起运机场：" v-show="search.LineType === 2">
              <el-select size="mini" placeholder="请选择起运机场" class="el-width-200" v-model="dialogInsert.form.ShipmentAirport" filterable>
                <el-option v-for="item in airportlist.filter(a=>a.countryId === dialogInsert.form.ShipmentRegion)" :key="item.id" :value="item.id" :label="item.airportName_CN+'['+item.iata+']'"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="起运港口：" v-show="search.LineType === 3">
              <el-select size="mini" placeholder="请选择起运港口" class="el-width-200" v-model="dialogInsert.form.ShipmentPort" filterable>
                <el-option v-for="item in portlist.filter(p=>p.countryId === dialogInsert.form.ShipmentRegion)" :key="item.id" :value="item.id" :label="item.portName_CN"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="起运FBA仓库：" v-show="search.LineType ===4">
              <el-select size="mini" placeholder="请选择起运FBA仓库" class="el-width-200" v-model="dialogInsert.form.ShipmentFBADepot" filterable>
                <el-option v-for="item in fbadepotlist.filter(f=>f.countryId ===dialogInsert.form.ShipmentRegion)" :key="item.id" :value="item.id" :label="item.depotCode"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="预计天数：" prop="EstimateDays">
              <el-input-number size="mini" v-model="dialogInsert.form.EstimatedMinDays" class="el-width-100" :precision="0"></el-input-number>
              -
              <el-input-number size="mini" v-model="dialogInsert.form.EstimatedMaxDays" class="el-width-100" :precision="0"></el-input-number>
            </el-form-item>
            <el-form-item label="追踪状态：">
              <el-checkbox v-model="dialogInsert.form.TrackState">可追踪</el-checkbox>
            </el-form-item>
            <div class="clear"></div>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="线路目的地" name="linepurpose">
          <el-table :data="dialogInsert.form.Purposes" :border="true" class="etms-router-list">
            <el-table-column label="序号" type="index" width="50px" align="center"></el-table-column>
            <el-table-column :label="'目的'+search.LineTypeLabel" align="center">
              <template slot-scope="scope">
                <el-select size="mini" v-model="scope.row.purposeCountryId" class="el-width-200" filterable @change=" (scope.$index,scope.row)">
                  <el-option v-for="item in countrylist" :key="item.id" :value="item.id" :label="item.countryName_CN[0]+'['+item.twoLetters+']'"></el-option>
                </el-select>
                <el-select size="mini" v-show="search.LineType===2" v-model="scope.row.purposeAirportId" class="el-width-200" filterable>
                  <el-option v-for="item in airportlist.filter(a=>a.countryId === scope.row.purposeCountryId)" :key="item.id" :value="item.id" :label="item.airportName_CN"></el-option>
                </el-select>
                <el-select size="mini" v-show="search.LineType===3" v-model="scope.row.purposePortId" class="el-width-200" filterable>
                  <el-option v-for="item in portlist.filter(p=>p.countryId === scope.row.purposeCountryId)" :key="item.id" :value="item.id" :label="item.portName_CN"></el-option>
                </el-select>
                <el-select size="mini" v-show="search.LineType===4" v-model="scope.row.purposeFBADepotId" class="el-width-200" filterable>
                  <el-option v-for="item in fbadepotlist.filter(f=>f.countryId === scope.row.purposeCountryId)" :key="item.id" :value="item.id" :label="item.depotCode"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column width="50px" align="center">
              <template slot="header" slot-scope="scope">
                <el-button size="mini" type="primary" icon="el-icon-plus" circle @click="purposeInsertClick"></el-button>
              </template>
              <template slot-scope="scope">
                <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="purposeDeleteClick(scope.$index)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="channellineSave">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="dialogUpload.dialogtitle" :visible.sync="dialogUpload.dialogvisible" :modal-append-to-body="false" center width="500px">
      <el-form label-width="120px" class="etms-dialog-form">
        <el-form-item label="渠道：">
          <el-select size="mini" placeholder="请选择渠道" filterable class="el-width-200" v-model="dialogUpload.form.ChannelId">
            <el-option v-for="item in channellist" :key="item.id" :value="item.id" :label="item.channelName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文件：" class="el-form-item-fill">
          <el-upload ref="upload" :action="constant.openPaths.importChannelLine" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" :file-list="dialogUpload.form.fileList" :limit="1" :http-request="importChannelLine" :before-remove="beforeRemove" :on-exceed="handleExceed" :auto-upload="false" list-type="text">
            <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过2mb</div>
          </el-upload>
        </el-form-item>
      </el-form>

      <div class="clear"></div>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left:10px;" size="small" type="success" @click="submitUpload">导入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data () {
    var existsLineCode = (rule, value, callback) => {
      var self = this
      var userinfo = this.$cookies.get('userinfo')
      if (userinfo !== null && userinfo !== undefined) {
        this.$ajax.post(this.constant.openPaths.existsChannelLineCode, {
          UserId: userinfo.id,
          EnterpriseId: userinfo.enterpriseId,
          LoginToken: userinfo.loginToken,
          LineCode: value,
          ChannelId: self.dialogInsert.form.ChannelId,
          Id: self.dialogInsert.form.Id
        }).then(res => {
          switch (res.data.code) {
            case 200:
              callback()
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              callback(res.data.msg)
              break;
          }
        }).catch(error => { callback(error) })
      }
    }

    var existsLineName = (rule, value, callback) => {
      var self = this
      var userinfo = this.$cookies.get('userinfo')
      if (userinfo !== null && userinfo !== undefined) {
        this.$ajax.post(this.constant.openPaths.existsChannelLineName, {
          UserId: userinfo.id,
          EnterpriseId: userinfo.enterpriseId,
          LoginToken: userinfo.loginToken,
          LineName: value,
          ChannelId: self.dialogInsert.form.ChannelId,
          Id: self.dialogInsert.form.Id
        }).then(res => {
          switch (res.data.code) {
            case 200:
              callback()
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              callback(res.data.msg)
              break;
          }
        }).catch(error => { callback(error) })
      }
    }

    var estimateDaysValidate = (rule, value, callback) => {
      if (this.dialogInsert.form.EstimatedMinDays !== null && this.dialogInsert.form.EstimatedMinDays !== undefined && this.dialogInsert.form.EstimatedMinDays !== '' && this.dialogInsert.form.EstimatedMaxDays !== null && this.dialogInsert.form.EstimatedMaxDays !== undefined && this.dialogInsert.form.EstimatedMaxDays !== '') {
        if (this.dialogInsert.form.EstimatedMinDays > this.dialogInsert.form.EstimatedMaxDays) {
          callback('日期范围异常')
        }
      }
      callback()
    }
    return {
      userinfo: this.$cookies.get('userinfo'),
      channellist: [],
      countrylist: [],
      airportlist: [],
      portlist: [],
      fbadepotlist: [],
      channellinelist: [],
      search: {
        pageindex: 1,
        pagesize: 100,
        recordcount: 0,
        LineType: 1,
        LineTypeLabel: '地区',
        ChannelId: '',
        LineName: ''
      },
      dialogInsert: {
        dialogtitle: '添加线路',
        dialogvisible: false,
        activename: 'lineinfo',
        form: {
          formname: 'lineform',
          Id: '',
          OptimisticLock: '',
          ChannelId: '',
          LineCode: '',
          LineName: '',
          ShipmentRegion: '',
          ShipmentAirport: '',
          ShipmentPort: '',
          ShipmentFBADepot: '',
          ShipmentDepot: '',
          EstimatedMinDays: '',
          EstimatedMaxDays: '',
          TrackState: '',
          Purposes: [],
          airportlist: [],
          portlist: [],
          fbadepotlist: [],
        },
        rules: {
          ChannelId: [
            { required: true, message: '请选择渠道', trigger: 'change' }
          ],
          LineCode: [
            { required: true, message: '请填写线路代码', trigger: 'blur' },
            { validator: existsLineCode, trigger: 'blur' }
          ],
          LineName: [
            { required: true, message: '请填写线路名称', trigger: 'blur' },
            { validator: existsLineName, trigger: 'blur' }
          ],
          EstimateDays: [
            { validator: estimateDaysValidate, trigger: 'blur' }
          ],
        },
      },
      dialogUpload: {
        dialogtitle: '导入线路',
        dialogvisible: false,
        form: {
          ChannelId: '',
          TemplateId: '',
          DepotType: '',
          fileList: []
        }
      },
    }
  },
  mounted () {
    this.initChannelList()
    this.initCountry()
    this.initAirportList()
    this.initPortList()
    this.initFBADepot()
    this.searchClick()
  },
  methods: {
    clearForm (form) {
      Object.keys(form).forEach(item => {
        if (item !== 'formname') {
          switch (typeof (form[item])) {
            case 'string':
              form[item] = ''
              break
            case 'number':
              form[item] = ''
              break
            case 'object':
              if (Array.isArray(form[item])) {
                form[item] = []
              } else { }
              break
          }
        }
      })
    },
    initChannelList () {
      var data = {
        UserId: this.userinfo.id,
        EnterpriseId: this.userinfo.enterpriseId,
        LoginToken: this.userinfo.loginToken,
        ChannelLineType: this.search.LineType
      }
      this.common.postAjaxRequest(this, this.constant.openPaths.getChannelList, data, 'channellist')
    },
    initCountry () {
      this.common.getAjaxRequest(this, this.constant.openPaths.getCountryList, 'countrylist')
    },
    initAirportList () {
      this.common.getAjaxRequest(this, this.constant.openPaths.getAirportList, 'airportlist')
    },
    initPortList () {
      this.common.getAjaxRequest(this, this.constant.openPaths.getPortList, 'portlist')
    },
    initFBADepot () {
      this.common.getAjaxRequest(this, this.constant.openPaths.getFBADepotList, 'fbadepotlist')
    },
    linetypeClick (item) {
      this.search.LineType = item.value
      this.search.LineTypeLabel = item.label
      this.initChannelList()
      this.searchClick()
    },
    searchClick () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          PageSize: this.search.pagesize,
          PageIndex: this.search.pageindex,
          ChannelId: this.search.ChannelId,
          ChannelLineName: this.search.LineName,
          ChannelLineType: this.search.LineType
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.searchChannelLinePager, data).then(res => {
          switch (res.data.code) {
            case 200:
              self.channellinelist = res.data.result.tList
              self.search.recordcount = res.data.result.recordCount
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              self.$message.error(res.data.msg)
              break;
          }
        })
      }
    },
    formatterShipmentName (row, column) {
      switch (this.search.LineType) {
        case 1:
          var country = this.countrylist.filter(item => item.id === row.shipmentRegion)[0]
          if (country !== undefined && country !== null) { return country.countryName_CN[0] }
          break
        case 2:
          var airport = this.airportlist.filter(item => item.id === row.shipmentAirportId)[0]
          if (airport !== undefined && airport !== null) { return airport.airportName_CN }
          break
        case 3:
          var port = this.portlist.filter(item => item.id === row.shipmentPortId)[0]
          if (port !== undefined && port !== null) { return port.portName_CN }
          break
        case 4:
          var fba = this.fbadepotlist.filter(item => item.id === row.shipmentFBADepotId)[0]
          if (fba !== undefined && fba !== null) { return fba.depotCode }
          break
      }
      return ''
    },
    formatterPurpose (row, column) {
      var result = ''
      row.purposes.forEach(item => {
        switch (this.search.LineType) {
          case 1:
            {
              var country = this.countrylist.filter(c => c.id === item.purposeCountryId)[0]
              if (country !== undefined && country !== null) {
                if (result.length > 0) {
                  result += '、' + country.countryName_CN[0]
                } else {
                  result = country.countryName_CN[0]
                }
              }
            }
            break
          case 2:
            {
              var airport = this.airportlist.filter(a => a.id === item.purposeAirportId)[0]
              if (airport !== undefined && airport !== null) {
                if (result.length > 0) {
                  result += '、' + airport.airportName_CN
                } else {
                  result = airport.airportName_CN
                }
              }
            }
            break
          case 3:
            {
              var port = this.portlist.filter(a => a.id === item.purposePortId)[0]
              if (port !== undefined && port !== null) {
                if (result.length > 0) {
                  result += '、' + port.portName_CN
                } else {
                  result = port.portName_CN
                }
              }
            }
            break
          case 4:
            {
              var fba = this.fbadepotlist.filter(a => a.id === item.purposeFBADepotId)[0]
              if (fba !== undefined && fba !== null) {
                if (result.length > 0) {
                  result += '、' + fba.depotCode
                } else {
                  result = fba.depotCode
                }
              }
            }
            break
        }
      })
      return result
    },
    formatterChannelName (row, column) {
      var channel = this.channellist.filter(item => item.id === row.channelId)[0]
      if (channel !== null && channel !== undefined) {
        return channel.channelName
      }
      return ''
    },
    insertChannelLine () {
      this.dialogInsert.dialogvisible = true
      this.dialogInsert.dialogtitle = '添加线路'
      this.clearForm(this.dialogInsert.form)
    },

    handleSizeChange (val) {
      this.search.pagesize = val
      this.searchClick()
    },
    handleCurrentChange (val) {
      this.search.pageindex = val
      this.searchClick()
    },
    purposeInsertClick () {
      this.dialogInsert.form.Purposes.push({
        purposeCountryId: '',
        purposeAirportId: '',
        purposePortId: '',
        purposeFBADepotId: ''
      })
    },
    purposeDeleteClick (index) {
      this.dialogInsert.form.Purposes.splice(index, 1)
    },
    channellineSave () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          Id: this.dialogInsert.form.Id,
          OptimisticLock: this.dialogInsert.form.OptimisticLock,
          ChannelId: this.dialogInsert.form.ChannelId,
          ShipmentRegion: this.dialogInsert.form.ShipmentRegion,
          ShipmentAirport: this.dialogInsert.form.ShipmentAirport,
          ShipmentPort: this.dialogInsert.form.ShipmentPort,
          ShipmentFBADepot: this.dialogInsert.form.ShipmentFBADepot,
          ShipmentDepot: this.dialogInsert.form.ShipmentDepot,
          Purposes: this.dialogInsert.form.Purposes,
          LineCode: this.dialogInsert.form.LineCode,
          LineName: this.dialogInsert.form.LineName,
          EstimatedMaxDays: this.dialogInsert.form.EstimatedMaxDays,
          EstimatedMinDays: this.dialogInsert.form.EstimatedMinDays,
          TrackState: this.dialogInsert.form.TrackState
        }
        var url = ''
        if (this.dialogInsert.form.Id === '' && this.dialogInsert.form.OptimisticLock === '') {
          url = this.constant.openPaths.insertChannelLine
        } else {
          url = this.constant.openPaths.updateChannelLine
        }
        var self = this
        this.$refs[this.dialogInsert.form.formname].validate((valid) => {
          if (valid) {
            this.$ajax.post(url, data).then(res => {
              switch (res.data.code) {
                case 200:
                  self.$message({ message: res.data.msg, type: 'success' })
                  self.clearForm(self.dialogInsert.form)
                  self.searchClick()
                  self.dialogInsert.dialogvisible = false
                  break;
                case 402:
                  self.$router.push({ name: 'login' })
                  break
                default:
                  self.$message.error(res.data.msg)
                  break;
              }
            })
          }
        })
      }
    },
    updateChannelLine (row) {
      this.dialogInsert.dialogvisible = true
      this.dialogInsert.dialogtitle = '修改线路'
      this.dialogInsert.form.Id = row.id
      this.dialogInsert.form.OptimisticLock = row.optimisticLock
      this.dialogInsert.form.ChannelId = row.channelId
      this.dialogInsert.form.LineCode = row.lineCode
      this.dialogInsert.form.LineName = row.lineName
      this.dialogInsert.form.ShipmentRegion = row.shipmentRegion
      this.dialogInsert.form.ShipmentAirport = row.shipmentAirportId
      this.dialogInsert.form.ShipmentPort = row.shipmentPortId
      this.dialogInsert.form.ShipmentFBADepot = row.shipmentFBADepotId
      this.dialogInsert.form.ShipmentDepot = row.shipmentDepotId
      this.dialogInsert.form.EstimatedMinDays = row.estimatedMinDays
      this.dialogInsert.form.EstimatedMaxDays = row.estimatedMaxDays
      this.dialogInsert.form.TrackState = row.trackState
      this.dialogInsert.form.Purposes = row.purposes
    },
    deleteChannelLine (row) {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          Id: row.id,
          OptimisticLock: row.optimisticLock,
        }
        var self = this
        this.$confirm('此操作将彻底删除此线路及价格折扣,是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          self.$ajax.post(self.constant.openPaths.deleteChannelLine, data).then(res => {
            switch (res.data.code) {
              case 200:
                self.$message({ message: res.data.msg, type: 'success' })
                self.searchClick()
                break;
              case 402:
                self.$router.push({ name: 'login' })
                break
              default:
                self.$message.error(res.data.msg)
                break;
            }
          }).catch(error => { self.$message.error(error) })
        })
      } else {
        this.$router.push({ name: 'login' })
      }
    },
    importChannelLine (content) {
      let formData = new FormData()
      formData.append('UserId', this.userinfo.id)
      formData.append('EnterpriseId', this.userinfo.enterpriseId)
      formData.append('LoginToken', this.userinfo.loginToken)
      formData.append('ChannelId', this.dialogUpload.form.ChannelId)
      formData.append('file', content.file)

      var self = this

      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.$ajax.post(this.constant.openPaths.importChannelLine, formData, config).then(res => {
        if (res.data.code === 200) {
          var result = res.data.result
          switch (res.data.code) {
            case 200:
              var failures = ''
              if (result !== undefined && result !== null) {
                result.forEach(item => {
                  if (failures.length > 0) {
                    failures = failures + '、' + item
                  } else {
                    failures = item
                  }
                })
              }
              var msg = ''
              if (result.length > 0) {
                msg = '导入成功,以下目的地不可用:' + failures + '.'
                self.$message({ message: msg, type: 'warning' })
              } else {
                self.$message({ message: res.data.msg, type: 'success' })
              }
              self.search.pageindex = 1
              self.searchClick()
              self.dialogUpload.dialogvisible = false
              self.clearForm(self.dialogUpload.form)
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              self.$message.error(res.data.msg)
              break;
          }
          // content.onSuccess(res.data.msg)
          // self.$message({
          //   message: res.data.msg,
          //   type: 'success'
          // })
        }
        else {
          self.$message.error(res.data.msg)
          content.onError(res.data.msg)
        }
      })
    },
    uploadChannelLine () {
      this.dialogUpload.dialogvisible = true
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    submitUpload () {
      this.$refs.upload.submit()
    },
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";

.line-type-ul {
  list-style: none;
  margin: 0;
  padding: 0;
  border-bottom: 2px solid #f2f2f2;
  margin-bottom: 5px;
}
.line-type-li {
  text-align: center;
  padding-right: 20px;
  line-height: 40px;
  cursor: pointer;
}

.line-type-li > div {
  line-height: 40px;
}

.line-type-li:hover {
  color: #409eff;
}

.active {
  color: #409eff;
  border-bottom: 2px solid #409eff;
}

.el-form-item {
  width: 50%;
  float: left;
}

.el-form-item-fill {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/etms/tms/line_manage.vue